import { NavItemProps } from "../SideNav/NavItem/NavItem";
import { INavItemParent, INavItemBase } from "Shared/types/NavItems";
import cloneDeep from "lodash/cloneDeep";
import get from "lodash/get";
import { ProviderPermissions } from "generated/graphql";
import { InitialPartnerConfigContextState } from "Hooks/usePartnerConfig";

const isEnabled = (
  navItem: INavItemBase,
  enabledFeatures: string[],
  permissions: ProviderPermissions,
  config: InitialPartnerConfigContextState
) => {
  const featureFlagEnabled =
    !navItem.featureFlag ||
    enabledFeatures.some(feature => feature === navItem.featureFlag);
  const permissionEnabled =
    !navItem.permission || permissions[navItem.permission];

  const otherConditionalsEnabled =
    !navItem.otherConditionals || navItem.otherConditionals.reduce((memo, conditional) => {
      return memo && get(config, conditional);
    }, true);

  return featureFlagEnabled && permissionEnabled && otherConditionalsEnabled;
};

export function getEnabledNavItems(
  navItems: NavItemProps[],
  enabledFeatures: string[],
  permissions: ProviderPermissions,
  config: InitialPartnerConfigContextState
) {
  let enabledNavItems: NavItemProps[] = [];
  const navItemsCopy = cloneDeep(navItems);

  enabledNavItems = navItemsCopy.filter(item => {
    const enabled = isEnabled(item, enabledFeatures, permissions, config);

    const parentItem = item as INavItemParent;
    if (parentItem.childProps && parentItem.childProps.length) {
      parentItem.childProps = parentItem.childProps.filter(childItem => {
        return isEnabled(childItem, enabledFeatures, permissions, config);
      });
    }
    return enabled;
  });

  return enabledNavItems;
}
